import { defineClientComponent } from './src/js/clientComponents.ts';
import Component from './src/pages/forfatter/[slug].tsx';
defineClientComponent('forfatter/[slug]', Component);